import { render, staticRenderFns } from "./EpMandates.vue?vue&type=template&id=d6cd8116"
import script from "./EpMandates.vue?vue&type=script&lang=js"
export * from "./EpMandates.vue?vue&type=script&lang=js"
import style0 from "./EpMandates.vue?vue&type=style&index=0&id=d6cd8116&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports